module.exports = __webpack_public_path__ + "static/images/animated-check-gray.svg";